import Home from './Home';

export { Home };
export default Home;
